<template>
    <!-- <div id="loading" class="loading-wrap loader">
        <ul class="loading">
            <li><img  rel="preload" loading="lazy"   src="@/assets/images/loading.gif" alt="loading"></li>
            <li>Loading...</li>
        </ul>
    </div> -->
    <div class="loader-section">
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</template>
<script>
export default{
    name:'Loader'
}
</script>